import { render, staticRenderFns } from "./PermissionChangedModal.vue?vue&type=template&id=69735da7&scoped=true"
import script from "./PermissionChangedModal.vue?vue&type=script&lang=ts"
export * from "./PermissionChangedModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69735da7",
  null
  
)

export default component.exports